<template>
  <main class="min-h-screen w-full bg-gray-100 p-4 space-y-4">
    <!-- HEADER + CREATE POST BUTTON -->
    <div class="flex items-center justify-between mb-2">
      <h1 class="text-2xl font-semibold text-gray-800">Process of Availment</h1>
      <button @click="openCreateModal"
        class="px-3 py-1.5 rounded bg-orange-500 text-white text-sm hover:bg-orange-600 transition">
        + Create Post
      </button>
    </div>

    <!-- POST LIST  -->
    <PostLists :posts="companyPosts" :show-meta="false" @edit="openEditModal" media-width="80%" media-height="80%" />

    <!-- CREATE / EDIT MODAL -->
    <CreatePostModal :show="showModal" :postToEdit="postBeingEdited" :show-meta="false" @close="closeModal"
      @refresh="refreshPosts" />
  </main>
</template>

<script>
import { ref, watch } from "vue";
import PostLists from "../announcements/Posts/PostLists.vue";
import CreatePostModal from "../announcements/Modals/CreatePostModal.vue";

export default {
  components: { PostLists, CreatePostModal },

  props: {
    passSectionItemPost: {
      type: Array,
      required: true,
      default: () => [],
    },
  },

  setup(props) {
    // Company profile posts (usually only 1 post, but PostLists supports multiple)
    const companyPosts = ref([]);

    // Modal state
    const showModal = ref(false);
    const postBeingEdited = ref(null);

    // Watch prop to populate posts
    watch(
      () => props.passSectionItemPost,
      (newPosts) => {
        companyPosts.value = newPosts.map((p) => ({ ...p }));
      },
      { immediate: true }
    );

    // Open create / edit modal
    const openCreateModal = () => {
      postBeingEdited.value = null;
      showModal.value = true;
    };
    const openEditModal = (post) => {
      postBeingEdited.value = post;
      showModal.value = true;
    };
    const closeModal = () => {
      showModal.value = false;
      postBeingEdited.value = null;
    };

    // Refresh posts after modal save
    const refreshPosts = () => {
      closeModal();
      // optionally re-fetch from API if needed
    };

    return {
      companyPosts,
      showModal,
      postBeingEdited,
      openCreateModal,
      openEditModal,
      closeModal,
      refreshPosts,
    };
  },
};
</script>
